import React from "react";
import Title from "../../../components/Title/Title";
import './SponsorsPage.scss';
import EPFLLogo from "../../../assets/epfl-logo.svg";
import DescoLogo from "../../../assets/desco-logo-blk.svg";

const Sponsors2025page = () => {
    return (
        <div>
            <Title>Sponsors</Title>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img
                    src={EPFLLogo}
                    alt="EPFL logo"
                    style={{ width: '35%', height: 'auto', marginBottom: '40px' }}
                />
                <img
                    src={DescoLogo}
                    alt="Desco logo"
                    style={{ maxWidth: '60%', height: 'auto' }}
                />
            </div>
        </div>
    );
}

export default Sponsors2025page
